<template>
  <el-pagination
    :page-size.sync="pageObj.pageSize"
    :page-sizes="pageObj.pageSizes"
    :total="pageObj.total"
    :current-page.sync="pageObj.current"
    layout="total, prev, pager, next, sizes,jumper"
    @size-change="sizeChangeHandler($event)"
    @current-change="pageChangeHandler"
  />
</template>

<script>
export default {
  props: {
    pageObj: {
      type: Object,
      default() {
        return {
          current: 1,
          pageSize: 20,
          total: 0,
          pageSizes:[10, 20, 30, 40, 50, 100]
        }
      }
    }
  },
  created() { 
    console.log(this.pageObj)
  },
  methods: {
    sizeChangeHandler(e) {
      this.$emit('sizeChange', e);
    },
    pageChangeHandler(e) { 
      this.$emit('currentChange', e);
    }
  }
}
</script>

<style>

</style>